import { type ReactNode } from 'react';
import { QuizQuestionHeading } from '../QuizQuestionHeading/QuizQuestionHeading';
import styles from './QuizForm.module.css';

type Props = {
  className?: string;
  childrenContainerClassName?: string;
  children: ReactNode;
  hero: ReactNode;
  secondaryCyid?: string;
  toolTip?: ReactNode;
  subCopy: ReactNode;
  questionSectionClassName?: string;
  footer: ReactNode;
  onSubmit: () => void;
};

export function QuizForm({
  childrenContainerClassName,
  children,
  className,
  subCopy,
  hero,
  toolTip,
  secondaryCyid,
  footer,
  questionSectionClassName,
  onSubmit,
}: Props) {
  return (
    <form
      className={`${styles.form} ${className}`}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className={`${styles.body} ${className}`}>
        <QuizQuestionHeading
          hero={hero}
          className={questionSectionClassName}
          subcopy={subCopy}
          testid={secondaryCyid}
          toolTip={toolTip}
        />
        <div className={`${styles.children} ${childrenContainerClassName}`}>
          {children}
        </div>
      </div>
      {footer}
    </form>
  );
}
